import { useManager } from 'dreamstate';
import { useEffect, useState } from 'react';

import { useToast } from '@vimeo/bokeh';
import { NotificationManager } from '@vimeo/live-core/store/notifications';

import { createLiveDomName } from '../../../libs/shared/utils/dom/identifying';

/**
 * General entrypoint for simple notifications.
 */
export function SimpleNotifications({
  id = createLiveDomName('simple-notification'),
  // eslint-disable-next-line react-hooks/rules-of-hooks
  notificationContext: { simpleNotification, notificationActions } = useManager(
    NotificationManager,
    ({ simpleNotification }) => [simpleNotification],
  ),
}) {
  const [count, setCount] = useState(0);
  const showToast = useToast();

  useEffect(() => {
    if (simpleNotification) {
      const { message, status, onComplete } = simpleNotification;

      showToast({
        id: createLiveDomName(id, count),
        title: message,
        status,
        onCloseComplete: () => {
          notificationActions.clearSimpleNotification();

          if (onComplete) {
            onComplete();
          }
        },
      });

      setCount((it) => it + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, notificationActions, simpleNotification]);

  return null;
}
